module.exports = __webpack_public_path__ + "img/1F510.451e00e8.svg";